import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

export const BackgroundContainer = styled(Box)({
  minHeight: '100vh',
  background: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
});

export const LoginContainer = styled(Box)({
  maxWidth: '800px',
  width: '100%',
});

export const PaperContainer = styled(Box)({
  padding: '40px',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(10px)',
});

export const LogoContainer = styled(Box)({
  textAlign: 'center',
  marginBottom: '30px',
  '& img': {
    maxWidth: '200px',
    height: 'auto',
  },
});

export const LoginHeader = styled(Typography)({
  textAlign: 'center',
  marginBottom: '30px !important',
  color: '#002F87',
  fontWeight: 'bold',
});

export const ReturningCustomerLink = styled(Typography)({
  textAlign: 'center',
  marginTop: '20px !important',
  marginBottom: '20px !important',
  color: '#666',
  fontSize: '1rem',
});

export const InformationHeading = styled(Typography)({
  textAlign: 'center',
  marginBottom: '30px !important',
  color: '#002F87',
  fontWeight: 'bold',
});

export const FormContainer = styled(Box)({
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
});

export const SubmitButton = styled(Button)({
  background: 'linear-gradient(45deg, #002F87 30%, #1e3a8a 90%)',
  color: 'white',
  padding: '12px 24px',
  fontSize: '1.1rem',
  fontWeight: 'bold',
  textTransform: 'none',
  borderRadius: '8px',
  marginTop: '20px',
  '&:hover': {
    background: 'linear-gradient(45deg, #1e3a8a 30%, #002F87 90%)',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0, 47, 135, 0.3)',
  },
  '&:disabled': {
    background: '#ccc',
    color: '#666',
  },
});

export const BackButton = styled(Button)({
  background: 'transparent',
  color: '#002F87',
  border: '2px solid #002F87',
  padding: '8px 24px',
  fontSize: '1rem',
  fontWeight: 'bold',
  textTransform: 'none',
  borderRadius: '8px',
  '&:hover': {
    background: '#002F87',
    color: 'white',
  },
});
